import { Injectable, inject } from '@angular/core';

import { Fai, ProductFactory, QuoteModel } from '@bytel/bytel-sales';
import { Oauth2Service } from '@bytel/checkout';

import { MainCartService } from '@services/main-cart.service';
import { PtoService } from '@services/pto.service';

import { tunnelRoutes } from '@tunnel/routes';

import { format, parseISO } from 'date-fns';
import { Observable, of } from 'rxjs';

import { FaiService } from '@services/fai.services';
import { BasicObject } from '../../../interfaces/checkout.interface';
import { PtoStep } from './pto.step';
import { Step } from './step';

@Injectable({
    providedIn: 'root',
})
export class AppointmentStep extends Step {
    public static readonly key: string = 'appointment';

    public routerLink: string = `/tunnel/${tunnelRoutes.appointment}`;
    public label: string = 'Choisissez la date et le créneau horaire du rendez-vous technicien';
    public shortLabel: string = 'Rendez-vous';
    public next: Step;
    public icon: string = 'tri-clipboard-checklist'; // to une once tri version is updated: tri-addcalendar-rdv
    public hasReminder = true;
    protected cartService = inject(MainCartService);
    protected oauth2Service = inject(Oauth2Service);
    protected ptoStep: PtoStep = inject(PtoStep);
    protected ptoService = inject(PtoService);
    protected faiService = inject(FaiService);
    constructor() {
        super();
        this._isLoaded.next(true);
    }

    public canAccess(): Observable<boolean> {
        return of(
            this.canDisplay() &&
                !!this.cartService.cartModel.cartId &&
                this.oauth2Service.isConnected &&
                this.ptoService._currentPto !== null,
        );
    }

    public canDisplay(): boolean {
        if (!this.faiService?.eligibility?.shouldBypass && !this.ptoStep.canDisplay()) {
            return false;
        }
        const quoteFai = this._getQuoteFai();
        if (quoteFai) {
            const principalSubscription: Fai = quoteFai.getPrincipalProduct<Fai>('Fai');
            return (
                ProductFactory.Is(principalSubscription, Fai, true) &&
                principalSubscription.technology === Fai.TECHNOLOGIES.FTTH
            );
        }

        return false;
    }

    public getReminderData(): string {
        const quoteFai = this._getQuoteFai();
        const storedAppointment: BasicObject = quoteFai?.forms?.appointment;
        if (storedAppointment) {
            const date: string = format(parseISO(storedAppointment.debutCreneau), 'dd/MM/yyyy');
            const start: string = format(parseISO(storedAppointment.debutCreneau), 'HH');
            const end: string = format(parseISO(storedAppointment.finCreneau), 'HH');
            return `Le ${date} entre ${start}h et ${end}h`;
        }
        return '';
    }

    private _getQuoteFai(): QuoteModel {
        return this.cartService.cartModel.quotes.find((quote) => quote.isAcquisitionFix());
    }
}
